import React from 'react';
import { Link } from 'react-router-dom';
import CarImage from '../../../assets/images/car_hood.png';
import '../../styles/Banner.css';
import { FaMapMarkerAlt, FaPhone, FaClock, FaCheck } from 'react-icons/fa';

const Banner = () => {
  return (
    <section className="hero-fullscreen">
      {/* Achtergrondlaag */}
      <div className="hero-bg-layer"></div>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Auto‑Service Thomas</h1>
          <p className="hero-subtitle">Specialist in herstellingen aan uw wagen</p>
          <p className="hero-subtitle">Mechaniek ‑ Carrosserie ‑ Restauratie</p>

          <ul className="hero-usp">
            <li><FaCheck className="usp-icon" /> Snelle service</li>
            <li><FaCheck className="usp-icon" /> Transparante prijzen</li>
            <li><FaCheck className="usp-icon" /> Klantgerichtheid</li>
          </ul>

          <div className="hero-cta">
            <Link to="/contact" className="cta-primary">Maak een afspraak</Link>
            <Link to="/tweedehands" className="cta-secondary">Onze tweedehandswagens</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
